import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

const gridLeadershipFields = [
  {
    name: 'heading',
    type: 'string',
  },
  imageField('image'),
  {
    name: 'content',
    type: 'object',
    subFields: [
      {
        name: 'body',
        type: 'richText',
      },
      imageField('signature'),
      {
        name: 'contact',
        type: 'richText',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const gridLeadershipConfig = {
  name: 'Grid Leadership',
  inputs: gridLeadershipFields,
};

export type GridLeadershipProps = GenerateBuilder<typeof gridLeadershipFields>;

export default gridLeadershipConfig;
